import { Button } from '@campgladiator/cgui-core.atoms.button'
import styles from './file-uploader.module.scss'

export type MediaType = 'PHOTO' | 'VIDEO'

export type FileUploaderProps = {
  disabled: boolean
  fileInputRef: React.Ref<HTMLInputElement> | undefined
  mediaType: MediaType
  supportedAttachmentTypes: string
  text: string
  onChange: (
    mediaType: MediaType,
    event?: React.ChangeEvent<HTMLInputElement>,
  ) => void
  onClick: (mediaType: MediaType, event?: React.MouseEvent<HTMLElement>) => void
}

const FileUploader = ({
  disabled,
  fileInputRef,
  mediaType,
  supportedAttachmentTypes,
  text,
  onClick,
  onChange,
}: FileUploaderProps) => (
  <div className={styles.fileUploaderWrapper}>
    <input
      accept={supportedAttachmentTypes}
      type="file"
      id={`select-file-${mediaType}`}
      className={styles.input}
      disabled={disabled}
      ref={fileInputRef}
      onChange={(event) => onChange(mediaType, event)}
    />

    <label
      htmlFor={`select-file-${mediaType}`}
      className={styles.fileUploaderLabel}
    >
      <Button
        emphasis="secondary"
        variation="outline"
        theme="trainer"
        onClick={(event) => onClick(mediaType, event)}
        icon={{
          name: 'icon-times',
          type: 'line',
        }}
        className={styles.fileUploader}
        disabled={disabled}
      >
        {text}
      </Button>
    </label>
  </div>
)

export default FileUploader
